import React from 'react';
import moment from 'moment';

import TaskIcon from '../../../assets/icons/TaskIcon';

import './surgeon-page.scss';

const SurgeonTasks = (props) => {
  const { tasks = [] } = props;

  return (
    <div className="surgeon-tasks__container">
      <div className='d-flex space-between p-t-md p-b-md p-l-lg p-r-md'>
        <div className='d-flex'>
          <TaskIcon color="var(--app-text)" />
          <div className='m-l-md font-bold font-size-lg'>
            Tasks
          </div>
        </div>
        <div />
      </div>
      <div className='surgeon-tasks__surgeon-tasks-list'>
        {tasks?.length ? (
          tasks?.map((item) => (
            <div key={item.id} className='surgeon-tasks__surgeon-task'>
              <div className='d-flex space-between'>
                <div className='font-bold'>{item.title}</div>
                <div className='font-size-sm secondary'>
                  {moment(item.createdAt).local().fromNow()}
                </div>
              </div>
              <div className='m-t-md'>
                {item.description}
              </div>
            </div>
          ))
        ) : (
          <div className='p-lg font-size-bg font-bold secondary d-flex flex-center'>
            No Tasks
          </div>
        )}
      </div>
    </div>
  );
};

export default SurgeonTasks;
